import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { CreateWarehouseParams } from 'entities/Warehouse';
import { useCreateWarehouse } from '../utils/hooks/useCreateWarehouse';

interface CreateWarehouseProps {
  warehouseData: CreateWarehouseParams;
  action: ReactElement;
}

export const CreateWarehouse: FC<CreateWarehouseProps> = memo((props) => {
  const { warehouseData, action } = props;

  const { t } = useAppTranslation('booking');

  const { createWarehouse, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useCreateWarehouse();

  const handleCreateWarehouse = useCallback((): void => {
    createWarehouse(warehouseData);
  }, [createWarehouse, warehouseData]);

  return (
    <>
      {React.cloneElement(action, { onClick: openConfirmModal })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Create warehouse')}
        description={t('Are you sure you want to create warehouse?')}
        isLoading={isLoading}
        onOk={handleCreateWarehouse}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
